module.exports = __webpack_public_path__ + "img/reduction.33ff0dea.svg";